import { rei } from "@/services/api"

class FunerariaSugestaoService {
  static getFunerariaSugestao (params) {
    const query = []

    params.nome && query.push('nome=' + params.nome)
    params.page && query.push('page=' + params.page)
    params.perPage && query.push('perPage=' + params.perPage)
    params.cartorio_id && query.push('cartorio_id=' + params.cartorio_id)

    return rei.get(`funeraria-sugestao?${query.join('&')}`).then(res => res.data)
  }

  static storeFunerariaSugestao (funerariaSugestao) {
    return rei.post(`funeraria-sugestao`, funerariaSugestao).then(res => res.data)
  }

  static updateFunerariaSugestao (funerariaSugestao, id) {
    return rei.put(`funeraria-sugestao/${id}`, funerariaSugestao).then(res => res.data)
  }

  static destroyFunerariaSugestao (id) {
    return rei.delete(`funeraria-sugestao/${id}`)
  }
}

export default FunerariaSugestaoService
